/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */

import { UpgradeToTraceTeamDialog } from "trux"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { webApi } from "../../lib/WebApi"
import React, { useState } from "react"

// Upgrade Trace Team Dialog

const UpgradeToTraceTeamDialogComponent = () => {

    const [processing, setProcessing] = useState(false)
    const [processingCompleted, setProcessingCompleted] = useState(false)

    // Get the history
    const history = useHistory()

    const handleOnClose = () => {
        history.push(
            history.location.pathname.replace(
                "/upgrade-trace-team",
                ""
            )
        )
    }

    // get the user_id from redux store
    const loggedInUser = useSelector((state) => state.user.value)
    let userName = loggedInUser && loggedInUser.first_name ? loggedInUser.first_name : ""
    userName = loggedInUser && loggedInUser.last_name ? userName + " " + loggedInUser.last_name : userName
    const userId = loggedInUser && loggedInUser.user_id ? loggedInUser.user_id : "NA"
    const userEmail = loggedInUser && loggedInUser.email ? loggedInUser.email : "NA"

    const handleOnUpgradeClick = () => {
        setProcessing(true)
        webApi.postSlack(
            `:warning: ATTENTION: \n\n ${userName} (ID: ${userId}) requested to upgrade to a trace team subscription. \n They can be reached via email at ${userEmail}. \n cc <@UJW5PNR96> <@U049L9L3D> <@U495U19BP> <@U02PZNMK9K8>`,
            null,
            null,
            "C4A826EJE"
        ).then(() => {
            setProcessing(false)
            setProcessingCompleted(true)
        }).catch(() => {
            setProcessing(false)
        })
    }

    return (
        <UpgradeToTraceTeamDialog 
            loading={processing}
            completed={processingCompleted}
            onUpgradeClick={handleOnUpgradeClick}
            onClose={handleOnClose} 
        />
    )
}

export default UpgradeToTraceTeamDialogComponent